import { BehaviorSubject } from 'rxjs';

import jsonStorage from '../utils/json-storage';

export const UserIsOfLegalAgeStore = {
  subject: null,

  _lazyInit() {
    if (UserIsOfLegalAgeStore.subject) return UserIsOfLegalAgeStore.subject;
    if (window?.localStorage) {
      const storage = window.localStorage;
      const userIsOfLegalAge = jsonStorage.get('userIsOfLegalAge', { storage });
      UserIsOfLegalAgeStore.subject = new BehaviorSubject(userIsOfLegalAge);
      return UserIsOfLegalAgeStore.subject;
    }
  },
  update: value => {
    const userIsOfLegalAge = UserIsOfLegalAgeStore._lazyInit();
    userIsOfLegalAge.next(value);
    const storage = window.localStorage;
    jsonStorage.set('userIsOfLegalAge', value, { storage });
  },
  subscribe: setState => {
    const userIsOfLegalAge = UserIsOfLegalAgeStore._lazyInit();
    return userIsOfLegalAge.subscribe(setState);
  },
  getValue: () => {
    const userIsOfLegalAge = UserIsOfLegalAgeStore._lazyInit();
    return userIsOfLegalAge.value;
  },
  clear: () => {
    UserIsOfLegalAgeStore.update(null);
    window.localStorage.removeItem('userIsOfLegalAge');
  },
};

export default { UserIsOfLegalAgeStore };
